import { SoapUtils } from "../../../utils/SoapUtils";

export interface ExternalContact {
  id?: number;
  contactId?: number;
  contextId?: number;
  note?: string;
  isPrimary?: number;
  relationshipLevel?: number;
  name1?: string;
  name2?: string;
  name3?: string;
  type?: number;
  email?: string;
  phone?: string;
  mobile?: string;
  deleteContact?: number;
}

export interface Rows {
  EXTERNAL_CONTACT: ExternalContact;
}

export interface ExternalContacts {
  count: string;
  ROWS: Rows[];
}

function toExternalContactsXml(ecs: ExternalContacts) {
  var result = '<EXTERNAL_CONTACTS>';
  if (ecs.ROWS) {
    result += SoapUtils.makeNode(ecs.count, 'count');
    if (+ecs.count > 0 && ecs.ROWS) {
      ecs.ROWS.forEach(ec => {
        result += '<EXTERNAL_CONTACT>';
        result += SoapUtils.makeNode(ec.EXTERNAL_CONTACT.id, 'id');
        result += SoapUtils.makeNode(ec.EXTERNAL_CONTACT.contactId, 'contactId');
        result += SoapUtils.makeNode(ec.EXTERNAL_CONTACT.contextId, 'contextId');
        result += SoapUtils.makeNode(ec.EXTERNAL_CONTACT.note, 'note');
        result += SoapUtils.makeNode(ec.EXTERNAL_CONTACT.isPrimary, 'isPrimary');
        result += SoapUtils.makeNode(ec.EXTERNAL_CONTACT.relationshipLevel, 'relationshipLevel');
        result += SoapUtils.makeNode(ec.EXTERNAL_CONTACT.name1, 'name1');
        result += SoapUtils.makeNode(ec.EXTERNAL_CONTACT.name2, 'name2');
        result += SoapUtils.makeNode(ec.EXTERNAL_CONTACT.name3, 'name3');
        result += SoapUtils.makeNode(ec.EXTERNAL_CONTACT.type, 'type');
        result += SoapUtils.makeNode(ec.EXTERNAL_CONTACT.email, 'email');
        result += SoapUtils.makeNode(ec.EXTERNAL_CONTACT.phone, 'phone');
        result += SoapUtils.makeNode(ec.EXTERNAL_CONTACT.mobile, 'mobile');
        result += SoapUtils.makeNode(ec.EXTERNAL_CONTACT.deleteContact, 'deleteContact');
        result += '</EXTERNAL_CONTACT>';
      });
    }
  }
  result += '</EXTERNAL_CONTACTS>';
  return result;
}

export interface Location {
  longitude: string;
  latitude:  string;
  TAG:       string;
}

function toLocationXml(location: Location) {
  var result = '<LOCATION>';
  result += SoapUtils.makeNode(location.longitude, 'longitude');
  result += SoapUtils.makeNode(location.latitude, 'latitude');
  result += SoapUtils.makeNode(location.TAG, 'TAG');
  result += '</LOCATION>';
  return result;
}

export interface Activity {
  acl?:                         string;
  aclh?:                        string;
  activity?:                    string;
  activityName?:                string;
  activityType?:                string;
  activityTypeName?:            string;
  comment?:                     string;
  created?:                     string;
  createdBy?:                   string;
  createdByName?:               string;
  customState?:                 string;
  customStateName?:             string;
  changeBillingConfirmation?:   string;
  defaultMessageContainer?:     string;
  defaultMessageContainerPath?: string;
  defaultMessageGroup?:         string;
  folder?:                      string;
  folderName?:                  string;
  folderTypeName?:              string;
  formId?:                      string;
  formName?:                    string;
  formValues?:                  string;
  guiAction?:                   string;
  id?:                          string;
  item?:                        string;
  itemName?:                    string;
  itemSerial?:                  string;
  keepModified?:                string;
  firstContactDate?:            string;
  lastContactDate?:             Date;
  lastDocDate?:                 Date;
  messageAcl?:                  string;
  modified?:                    string;
  modifiedBy?:                  string;
  modifiedByName?:              string;
  name?:                        string;
  notificationId?:              string;
  organization?:                string;
  pricing?:                     string;
  pricingName?:                 string;
  project?:                     string;
  projectName?:                 string;
  masterProjectId?:             string;
  masterProjectName?:           string;
  refId?:                       string;
  state?:                       string;
  templateAcc?:                 string;
  treeHandle?:                  string;
  typeFormId?:                  string;
  typeName?:                    string;
  requestHash?:                 string;
  dimension1?:                  string;
  dimension2?:                  string;
  dimension3?:                  string;
  contextParent?:               string;
  contextParentName?:           string;
  provider?:                    string;
  customer?:                    string;
  startDate?:                   Date;
  finalDate?:                   Date;
  masterActivity?:              string;
  LOCATION?:                    Location;
  EXTERNAL_CONTACTS?:           ExternalContacts;
}

export function toActivityXml(activity: Activity): string {
  var response = '<ACTIVITY>';

  response += SoapUtils.makeNode(activity.acl, 'acl');
  response += SoapUtils.makeNode(activity.aclh, 'aclh');
  response += SoapUtils.makeNode(activity.activity, 'activity');
  response += SoapUtils.makeNode(activity.activityName, 'activityName');
  response += SoapUtils.makeNode(activity.activityType, 'activityType');
  response += SoapUtils.makeNode(activity.activityTypeName, 'activityTypeName');

  response += SoapUtils.makeNode(activity.comment, 'comment');
  response += SoapUtils.makeNode(activity.created, 'created');
  response += SoapUtils.makeNode(activity.createdBy, 'createdBy');
  response += SoapUtils.makeNode(activity.createdByName, 'createdByName');
  response += SoapUtils.makeNode(activity.customState, 'customState');
  response += SoapUtils.makeNode(activity.customStateName, 'customStateName');
  response += SoapUtils.makeNode(activity.changeBillingConfirmation, 'changeBillingConfirmation');

  response += SoapUtils.makeNode(activity.defaultMessageContainer, 'defaultMessageContainer');
  response += SoapUtils.makeNode(activity.defaultMessageContainerPath, 'defaultMessageContainerPath');
  response += SoapUtils.makeNode(activity.defaultMessageGroup, 'defaultMessageGroup');

  response += SoapUtils.makeNode(activity.folder, 'folder');
  response += SoapUtils.makeNode(activity.folderName, 'folderName');
  response += SoapUtils.makeNode(activity.folderTypeName, 'folderTypeName');
  response += SoapUtils.makeNode(activity.formId, 'formId');
  response += SoapUtils.makeNode(activity.formName, 'formName');
  response += SoapUtils.makeNode(activity.formValues, 'formValues');

  response += SoapUtils.makeNode(activity.guiAction, 'guiAction');

  response += SoapUtils.makeNode(activity.id, 'id');
  response += SoapUtils.makeNode(activity.item, 'item');
  response += SoapUtils.makeNode(activity.itemName, 'itemName');
  response += SoapUtils.makeNode(activity.itemSerial, 'itemSerial');
  response += SoapUtils.makeNode(activity.keepModified, 'keepModified');
  response += SoapUtils.makeNode(activity.firstContactDate, 'firstContactDate');

  response += SoapUtils.makeNode(activity.lastContactDate, 'lastContactDate');
  response += SoapUtils.makeNode(activity.lastDocDate, 'lastDocDate');

  response += SoapUtils.makeNode(activity.messageAcl, 'messageAcl');
  response += SoapUtils.makeNode(activity.modified, 'modified');
  response += SoapUtils.makeNode(activity.modifiedBy, 'modifiedBy');
  response += SoapUtils.makeNode(activity.modifiedByName, 'modifiedByName');

  response += SoapUtils.makeNode(activity.name, 'name');
  response += SoapUtils.makeNode(activity.notificationId, 'notificationId');
  response += SoapUtils.makeNode(activity.organization, 'organization');

  response += SoapUtils.makeNode(activity.pricing, 'pricing');
  response += SoapUtils.makeNode(activity.pricingName, 'pricingName');
  response += SoapUtils.makeNode(activity.project, 'project');
  response += SoapUtils.makeNode(activity.projectName, 'projectName');

  response += SoapUtils.makeNode(activity.masterProjectId, 'masterProjectId');
  response += SoapUtils.makeNode(activity.masterProjectName, 'masterProjectName');

  response += SoapUtils.makeNode(activity.refId, 'refId');
  response += SoapUtils.makeNode(activity.state, 'state');

  response += SoapUtils.makeNode(activity.templateAcc, 'templateAcc');
  response += SoapUtils.makeNode(activity.treeHandle, 'treeHandle');
  response += SoapUtils.makeNode(activity.typeFormId, 'typeFormId');
  response += SoapUtils.makeNode(activity.typeName, 'typeName');

  response += SoapUtils.makeNode(activity.requestHash, 'requestHash');
  response += SoapUtils.makeNode(activity.dimension1, 'dimension1');
  response += SoapUtils.makeNode(activity.dimension2, 'dimension2');
  response += SoapUtils.makeNode(activity.dimension3, 'dimension3');

  response += SoapUtils.makeNode(activity.contextParent, 'contextParent');
  response += SoapUtils.makeNode(activity.contextParentName, 'contextParentName');

  response += SoapUtils.makeNode(activity.provider, 'provider');
  response += SoapUtils.makeNode(activity.customer, 'customer');
  response += SoapUtils.makeNodeDate(activity.startDate, 'startDate');
  response += SoapUtils.makeNodeDate(activity.finalDate, 'finalDate');

  response += SoapUtils.makeNode(activity.masterActivity, 'masterActivity');
  if (activity.LOCATION) response += toLocationXml(activity.LOCATION);
  if (activity.EXTERNAL_CONTACTS) response += toExternalContactsXml(activity.EXTERNAL_CONTACTS);

  response += '</ACTIVITY>';
  return response;
}
